"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireWildcard(require("../Input"));

var _Loading = _interopRequireDefault(require("../../../DataViz/Loading/Loading"));

var _animations = require("@staccx/animations");

var _theming = require("../../../../theming");

var _themeContants = require("../../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var axiosInstance = _axios["default"].create({
  baseURL: "https://api.bring.com/shippingguide/api"
});

function getAxiosOptions() {
  var opt = {
    transformRequest: [function (data, headers) {
      delete headers.common.Authorization;
      return data;
    }]
  };
  return opt;
}
/**
 * Input for Norwegian Postal codes. Adds PostalPlace according to the number. Input is imported from Input-component
 */


var PostalCodeInput = function PostalCodeInput(_ref) {
  var defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ["defaultValue", "onChange", "variant"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      place = _useState2[0],
      setPlace = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      postalCode = _useState4[0],
      setPostalCode = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var inputRef = (0, _react.useRef)(null);

  var getPostalPlace =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _place;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return axiosInstance.get("/postalCode.json?clientUrl=".concat(window.location.href, "&pnr=").concat(postalCode), getAxiosOptions()).then(function (result) {
                return result.data;
              });

            case 4:
              _place = _context.sent;
              setPlace(_place);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 11:
              setIsLoading(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function getPostalPlace() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleChange = function handleChange(e) {
    var value = e.target.rawValue;
    setPostalCode(value);
  };

  (0, _react.useEffect)(function () {
    if (postalCode && !isNaN(postalCode) && postalCode.length >= 4) {
      getPostalPlace(postalCode);
    } else {
      setPlace(null);
    }
  }, [postalCode]);
  (0, _react.useEffect)(function () {
    if (onChange) {
      onChange({
        place: place,
        postalCode: postalCode
      });
    }
  }, [place, postalCode]);
  (0, _react.useEffect)(function () {
    if (postalCode !== defaultValue) {
      setPostalCode(defaultValue);
      inputRef.current.setRawValue(defaultValue);
    }
  }, [defaultValue]);
  return _react["default"].createElement(PostalInputWrapper, {
    variant: variant
  }, _react["default"].createElement(PostalInput, _extends({
    type: "text",
    pattern: "[0-9]{4}",
    options: {
      blocks: [4]
    },
    defaultValue: defaultValue,
    variant: variant
  }, restProps, {
    onChange: handleChange,
    ref: inputRef
  })), isLoading && _react["default"].createElement(_Loading["default"], null), place && _react["default"].createElement(Location, {
    valid: place.valid,
    variant: variant
  }, place.result));
};

PostalCodeInput.themeProps = {
  wrapper: {
    name: "POSTAL_WRAPPER",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  location: {
    name: "POSTAL_LOCATION",
    description: "Location style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "POSTAL_INPUT",
    description: "Specific Input style",
    type: _themeContants.themePropTypes.style
  }
};

var PostalInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PostalCodeInput__PostalInputWrapper",
  componentId: "sc-16teacj-0"
})(["position:relative;display:flex;align-items:flex-end;justify-content:flex-start;", ";"], (0, _theming.applyVariants)(PostalCodeInput.themeProps.wrapper));

var Location = _styledComponents["default"].div.withConfig({
  displayName: "PostalCodeInput__Location",
  componentId: "sc-16teacj-1"
})(["padding-left:", ";min-height:", ";align-items:center;vertical-align:middle;display:flex;font-size:", ";color:", ";opacity:0;animation:", " 0.8s ease-out forwards 1;", ";"], _theming.spacing.small, _theming.targetSize.normal, _theming.font.input, function (p) {
  return p.valid ? (0, _theming.color)("wcag")(p) : (0, _theming.color)("warning")(p);
}, _animations.FadeIn, (0, _theming.applyVariants)(PostalCodeInput.themeProps.location));

var PostalInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "PostalCodeInput__PostalInput",
  componentId: "sc-16teacj-2"
})(["width:5em;", ";"], (0, _theming.applyVariants)(PostalCodeInput.themeProps.input)); // TODO: debounce calls?

PostalCodeInput.propTypes = _objectSpread2({}, _Input.InputPropTypes, {
  locale: _propTypes["default"].oneOf(["nb"]),
  onChange: _propTypes["default"].func
});
PostalCodeInput.defaultProps = {
  locale: "nb"
};
var _default = PostalCodeInput;
exports["default"] = _default;